import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface CloudHostingProps {}

const CloudHosting = ({}: CloudHostingProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Cloud Hosting")}
          subtitle={t("Services")}
          thirdTitle={t("Cloud Hosting")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/CloudHostingintro.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "Experience unparalleled performance and reliability with our Cloud Hosting solutions at Onyxcom. We offer scalable, secure, and high-speed hosting services that ensure your website remains fast, accessible, and resilient, no matter the traffic demands. Easily adjust your resources to handle traffic spikes and growth without downtime or performance issues. Advanced security measures to protect your data and maintain privacy, including encryption, firewalls, and regular security audits. Optimized servers and global Content Delivery Networks (CDNs) to deliver fast loading times for users anywhere in the world."
              )}
            </p>
          </div>
        </section>

        {/* grid section  *******************************/}
        <section className="my-[100px] w-full px-[20px] lg:px-[260px]">
          <div
            className={`my-[20px] flex items-center justify-around  text-[12px] lg:text-[20px] ${
              i18n.language === "en"
                ? "lg:text-left lg:pl-[100px]"
                : "lg:text-right lg:pr-[100px]"
            }`}
          >
            <p className="w-full"></p>
            <p className="w-full font-[700] ">{t("Business")}</p>
            <p className="w-full font-[700] ">{t("Pro")}</p>
            <p className="w-full font-[700] ">{t("High-traffic")}</p>
          </div>
          <div className="w-full  border-[1px] border-[#0804B5] rounded-[20px] text-[10px] lg:text-[16px]">
            <div className="flex items-center justify-around border-b-2 ">
              <p className="py-[5px] lg:p-[30px] w-full lg:bg-first_color/15 rounded-tl-[20px] text-first_color font-[500] flex items-center justify-center">
                {t("Disk Space")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("10GB of storage")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("25GB of storage")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("50GB of storage")}
              </p>
            </div>

            <div className="flex items-center justify-around border-b-2">
              <p className="py-[5px] lg:p-[30px] w-full lg:bg-first_color/15  text-first_color font-[500] flex items-center justify-center">
                {t("Network transfer")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("250GB Network transfer")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("500GB Network transfer")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("1TB Network transfer")}
              </p>
            </div>

            <div className="flex items-center justify-around">
              <p className="py-[5px] lg:p-[30px] w-full lg:bg-first_color/15 rounded-bl-[20px] text-first_color font-[500] flex items-center justify-center">
                {t("Average visitors")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("Average 25k visitors")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("Average 125k visitors")}
              </p>
              <p className="py-[5px] lg:p-[30px] w-full">
                {t("Average 500k visitors")}
              </p>
            </div>
          </div>
        </section>

        {/* Why Our Cloud Hosting Service **************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Why Our Cloud Hosting Service")}
          </p>
          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="font-[700] text-[20px]">
                {t("Self-Healing Hardware")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Our whole infrastructure is cloud-based. Every server is self-healing: if any hardware fails, automatic failover ensures quick recovery."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Scale with Demand")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Onyxcom Cloud Brain is able to dynamically assign RAM and CPU as a server needs. Think, Elastic."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Multiple Location")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Choice of multiple clouds throughout the USA, Europe and Asia. Backup, replicate and deploy 1 to 100 servers in minutes, wherever you need them."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Faster Disks")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Our cloud storage units are powered by 48 drives in RAID10 and replicated real time via Multipath I/O to give a total of 96 drives of full redundancy."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Spam-free Network")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We analyze all email, ensuring everyone on our network is playing nice. No spammers on this network – ensuring all IPs are RBL free."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("60 day Money-back Guarantee")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "If you’re not happy, we’re not happy. A 60 day Money Back guarantee is included on all Cloud Hosting packages."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("A Control Panel you know - cPanel")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "You get the benefits of the cloud’s scalability with the flexibility of cPanel. One click installs, FTP, SSH, everything you need."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Fully Redundant, Distributed DNS")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Onyxcom utilizes an Anycast DNS system powered by dnsrecord.com – thirteen locations, your visitors use the closest fastest one, always."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Free Incoming Migrations")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We’re happy to help you move your website to node.ae free of charge on our pro and high traffic plans."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Right to Refuse Service")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Search Engine ranking is important, and Google has publicly said they can and have banned complete hosting servers for abusive sites.."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Faster Webserver")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Our features the Litespeed Webserver on all our clouds. is able deliver your site faster to visitors than competing free community-supported web servers."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("True Multi-domain Hosting")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "we have built in bulk volume discounts and full API available for automating provisioning."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default CloudHosting;
